import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import api from "../../../API";
import { useSelector } from "react-redux";

interface rejectProps {
  email: string;
  idx: number;
  setRejectPageOpen: React.Dispatch<React.SetStateAction<boolean>>
  // setOpen:React.Dispatch<React.SetStateAction<boolean>>;
  // getMemberList:any;
}

// const SampleRejectRsnDialog = () => {
const AddPartnerDialog = (props: any) => {

  const [reject_rsn , setReject_rsn] = useState("");

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const addPartner = async (v:any) => {

    await api.post("/addPartner",v)
    .then((res:any) => {alert("연결화자 등록이 완료되었습니다."); props.setAddPartnerDialog(false); props.getPartnerList(); })
    .catch((e) => {alert("연결화자 등록 오류가 발생하였습니다.")})

  }
  

  return (
    <Box >
    <Dialog maxWidth="sm" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>연결화자 추가</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
          <Box sx={{width:"100%"}}>
              
            <Formik
                initialValues={{email: email,name:"",agegroup:"10",gender:"남성"}}
                onSubmit={(values) => {
                  console.log(values);
                  addPartner(values);
                }}
              >
                {({ values, handleChange, setFieldValue, submitCount }) => (
                  <Form>
                    <Box sx={{display:"flex", alignItems:"center", marginBottom:"4px"}}>
                      <Box sx={{fontWeight:700, width:"80px", marginLeft:"24px"}}>이름</Box>
                      <TextField id="name" name="name" size="small" sx={{width:"200px",height: "40px", border:"2px solid #498ad5", borderRadius:"4px"}}
                        value={values.name} // Formik의 values에서 필드 값을 가져옵니다.
                        onChange={(e) => {
                          handleChange(e);
                        }}
                      />
                    </Box>
                    <Box sx={{display:"flex", alignItems:"center", marginBottom:"4px"}}>
                      <Box sx={{fontWeight:700, width:"80px", marginLeft:"24px"}}>나이대</Box>
                      <Select id="agegroup" name="agegroup" value={values.agegroup} onChange={(e)=>handleChange(e)} sx={{width:"200px",height: "44px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"10"}>10</MenuItem>
                        <MenuItem dense value={"20"}>20</MenuItem>
                        <MenuItem dense value={"30"}>30</MenuItem>
                        <MenuItem dense value={"40"}>40</MenuItem>
                        <MenuItem dense value={"50"}>50이상</MenuItem>
                      </Select>
                    </Box>
                    <Box sx={{display:"flex", alignItems:"center", marginBottom:"4px"}}>
                      <Box sx={{fontWeight:700, width:"80px", marginLeft:"24px"}}>성별</Box>
                      <Select id="gender" name="gender" value={values.gender} onChange={(e)=>handleChange(e)} sx={{width:"100px",height: "44px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"남성"}>남성</MenuItem>
                        <MenuItem dense value={"여성"}>여성</MenuItem>
                      </Select>
                    </Box>
                    
                    
                    {/* {submitCount ? <Button variant="contained" sx={{backgroundColor:"#03cf5d"}}>완료</Button>: <Button variant="contained" type="submit">할당</Button>} */}
                    <Button variant="contained" type="submit" sx={{fontWeight:700, display:"flex",marginLeft:"auto"}}>추가</Button>
                    
                  
                  </Form>
                )}
              </Formik>
          </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setAddPartnerDialog(false);
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default AddPartnerDialog;
